"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
const styleOverrides = {
  root: ({
    theme
  }) => ({
    textTransform: 'none',
    minWidth: 'unset',
    minHeight: 'unset',
    fontSize: theme.typography.body1.fontSize,
    padding: '10px 4px',
    marginRight: theme.spacing(4),
    [_breakpoints.default.up('md')]: {
      minWidth: 'unset',
      marginRight: theme.spacing(12),
      fontSize: '2rem',
      padding: '12px 4px'
    },
    [_breakpoints.default.up('lg')]: {
      fontSize: '2rem'
    },
    '&:last-child': {
      marginRight: 0
    }
  }),
  textColorPrimary: ({
    theme
  }) => ({
    color: theme.palette.grey.A700,
    [`&.${_material.tabClasses.selected}`]: {
      color: theme.palette.text.primary
    }
  })
};
const defaultProps = {
  disableRipple: true
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
